export default __webpack_public_path__ + "static/media/ascap_csv_help.29dc91eb.png";